<template>
	<CharacteristicEdit
		:value="value"
		title="Steuertätigkeiten"
		sub-title="Je genauer du die Aufgaben beschreibst, desto attraktiver wird die Aufgabe für InteressentInnen."
		with-keyword
		:characteristic-items="meta.functionTaxRole"
		:characteristic-type="meta.functionTaxRoleType"
		:nothing-allowed="{
			onlyOverall: true,
			overall: {
				inFan: true,
				text: 'Keine der zur Auswahl stehenden'
			}
		}"
		:supplements-config="{
			disable: true
		}"
		:selected-items-config="{
			showExperience: false,
		}"
		label-type="job-profile"
		open-fan-button-alignment="left"
		open-fan-label="Hinzufügen"
		open-fan-label-with-selection="Bearbeiten"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import CharacteristicEdit from "@/vue/characteristic/Edit";

export default {

	components: {
		CharacteristicEdit,
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
	},
}
</script>
